import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useLangue } from '../i18n/LangueContext';

const Pied = () => {
  const { t } = useLangue();
  const navigate = useNavigate();
  const location = useLocation();

  const allerVers = (cible) => (e) => {
    e.preventDefault();
    if (cible.startsWith('/#')) {
      const id = cible.slice(2);
      if (location.pathname === '/') {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        navigate('/', { state: { ancre: id } });
      }
    } else {
      navigate(cible);
    }
  };

  const colonne = (titre, liens) => (
    <div>
      <h4>{titre}</h4>
      <ul>
        {liens.map((x) => (
          <li key={x.to + x.l}>
            {x.to.startsWith('/#') ? (
              <a href={x.to} onClick={allerVers(x.to)}>{x.l}</a>
            ) : (
              <Link to={x.to}>{x.l}</Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <footer className="pied">
      <div className="conteneur">
        <div className="pied-grille">
          <div>
            <Link to="/" className="marque">Datasectoriel</Link>
            <p style={{ fontSize: '.95rem', marginTop: '1rem', maxWidth: '34ch' }}>{t.pied.baseline}</p>
          </div>
          {colonne(t.pied.projets, t.pied.liensProjets)}
          {colonne(t.pied.partenaires, t.pied.liensPartenaires)}
          {colonne(t.pied.societe, t.pied.liensSociete)}
        </div>
        <div className="pied-bas">
          <span>{t.pied.bas}</span>
        </div>
      </div>
    </footer>
  );
};

export default Pied;
